import { NgModule } from '@angular/core';

import { StoreRoutingModule } from './store-routing.module';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { SliderComponent } from './components/home/sections/slider/slider.component';
import { TrendingSideComponent } from './components/home/sections/trending-side/trending-side.component';
import { BannerSideComponent } from './components/home/sections/banner-side/banner-side.component';
import { PromoBannerSideComponent } from './components/home/sections/promo-banner-side/promo-banner-side.component';
import { FeatureCategoryComponent } from './components/home/sections/feature-category/feature-category.component';
import { BrandSideComponent } from './components/home/sections/brand-side/brand-side.component';
import { SocialSideComponent } from './components/home/sections/social-side/social-side.component';
import { HomeComponent } from './components/home/home.component';
import { PageTitleComponent } from './containers/page-title/page-title.component';
import { ProductPageComponent } from './components/product-page/product-page.component';
import { GalleryDetailComponent } from './components/product-page/sections/gallery-detail/gallery-detail.component';
import { ProductDescOneComponent } from './components/product-page/sections/product-desc-one/product-desc-one.component';
import { ProductDescTwoComponent } from './components/product-page/sections/product-desc-two/product-desc-two.component';
import { OfYourInterestComponent } from './components/product-page/sections/of-your-interest/of-your-interest.component';
import { ProductBundleComponent } from './components/product-page/sections/product-bundle/product-bundle.component';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { StoreModule as StoreReducerModule } from '@ngrx/store';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    NavBarComponent,
    SliderComponent,
    TrendingSideComponent,
    BannerSideComponent,
    PromoBannerSideComponent,
    FeatureCategoryComponent,
    BrandSideComponent,
    SocialSideComponent,
    HomeComponent,
    PageTitleComponent,
    ProductPageComponent,
    GalleryDetailComponent,
    ProductDescOneComponent,
    ProductDescTwoComponent,
    OfYourInterestComponent,
    ProductBundleComponent
  ],
  imports: [
    StoreReducerModule.forRoot({}),
    SharedModule,
    StoreRoutingModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent
  ]
})
export class StoreModule { }
